import c from "./lib/createApi";

import axios from "axios";
import getToken from "./lib/getToken";

export default {
  gets: c("GET", "/v1/protocol", true), // 프로토콜 이름으로 검색
  takey: c("GET", "/v1/protocol", false), // takey 있을때 사용
  put: c("PUT", "/v1/protocol", true), // 프로토콜 수정
  create: c("POST", "/v1/protocol", true), // 프로토콜 생성
  delete: c("DELETE", "/v1/protocol", true), // 프로토콜 삭제
  active: c('POST', '/v1/protocol/active', true), //프로토콜 비활성화
  overwrite : c('POST', '/v1/protocol/overwriteProtocol', true), //프로토콜 덮어쓰기
  connectProtocolUpdate : c('PUT', '/v1/protocol/connectProtocolUpdate/:id', true), //프로토콜 덮어쓰기
  my : {
    get : c('GET' , '/v1/protocol/:id/optionUser' , true) ,
  } , 

  detail: c('GET' , '/v1/protocol/:id/log' , true),
  getProtocols: c("GET", `/v1/protocol`, true), // [공정도 - 6] 내 상세 조회
  search: c("GET", "/v1/protocol/search", true), // 프로토콜 검색
  protocolContent: {
    get : c('GET', '/v1/protocol/protocolContent', true),
    put : c('PUT', '/v1/protocol/protocolContent', true)
  },
  protocolComment: {
    get : c('GET', '/v1/protocol/protocolComment', true),
    put : c('PUT', '/v1/protocol/protocolComment', true)
  },
  // GET ​/api​/v1​/protocol​/{processId}​/log
  optionUser: {
    get: c("GET", "/v1/protocol/:id/optionUser", true), // 프로토콜 공개정보 가져오기
    put: c("PUT", "/v1/protocol/:id/optionUser", true), // 프로토콜 공개정보 가져오기
  },
  memo : {
    get : c( "GET" , "v1/protocol/protocolMemo" , true ) , 
    put : c( "PUT" , "v1/protocol/protocolMemo" , true ) 
  } , 
  unit : {
    get : c('GET', '/v1/protocol/unitProtocol', true),
    connectLog : c('PUT',    '/v1/protocol/unit/connectLog', true), // 프로토콜에 유닛 연결.
    // deleteLog  : c('PUT',    '/v1/protocol/unit/deleteLog' , true), // 프로토콜에 연결된 유닛 삭제로그 저장. >> 삭제로그 필요시 open > insert 동작 확인 필요.
  },
  protocolCopyrightLog : {
    get: c('get','/v1/protocol/copyrightLog/:id', true),
  },
  log : {
    get: c('GET' , '/v1/protocol/:id/log' , true),
    getByLogId: c('GET' , '/v1/protocol/:id/logDetail' , true),
  } , 
  collaborator: {
    get: c('GET','/v1/protocol/collaborator', true),
    delete: c('DELETE','/v1/protocol/collaborator', true),
    add: c('POST','/v1/protocol/collaborator', true)
  },
  callUtil: c('POST','/v1/protocol/callUtil', true),
  searchForProtocoId: c("GET", "/v1/protocol/searchForProtocoId", true), // 프로토콜 ID로 검색
  connect : c('POST','/v1/protocol/connect', true), // 프로토콜 연결
  utilize : c('POST','/v1/protocol/utilize', true), // 프로토콜 활용
  release : {
    create: c('POST','/v1/protocol/release', true),
    get: c('GET','/v1/protocol/release', true),
    search: c('POST','/v1/protocol/releaseSearch', true), // 공개된 데이터 조회 (통합검색)
    detail: c("GET", '/v1/protocol/releaseDetail', true), // 공개 데이터 상세 조회 new (공개 테이블 분리 적용)
    update: c("PUT", '/v1/protocol/releaseUpdate', true), // 공개 데이터 최신 데이터로 update (재료, 목적, 장비)
  } ,
  connectProtocoList : c('GET','/v1/protocol/connectProtocoList', true), // 프로토콜 연결 리스트 불러오기.
  disconnectProtocolList : c('POST','/v1/protocol/disconnect', true), // 프로토콜 연결끊기
  duplicateCheck : c('POST','/v1/protocol/duplicateCheck', true), // 프로토콜 연결 중복확인
  exportProtocol : c('POST','/v1/protocol/exportProtocol', true), // 프로토콜 내보내기
  autoSave : { // 자동저장
    create : c("POST", "/v1/protocol/autoSave/create", true), // 프로토콜 수정시 로그 저장
  },
  deactivate : c('POST','/v1/protocol/deactivate', true), // 프로토콜 비활성화 (active => 1) (기존의 삭제 기능)
  nodeUpdate : c('POST','/v1/protocol/nodeUpdate', true), // 공정도 연결 시 node update.
  connectProcessThumbnail : c('GET', '/v1/protocol/connect-process-thumbnail', true), // 프로토콜에 연결된 공정도 썸네일 조회
};

// /api/v1/protocol/protocolMemo
// protocolId *
// tagKey *
